import {
    type AnalyticsClientInterface,
    type ContactType,
    type AnalyticsDateRangeParam,
    axiosCacheInterceptorRequestConfig,
} from './analyticsClient.types';
import BaseClient, { type BaseClientConfig } from '../BaseClient';

export default class GroupAnalyticsClient extends BaseClient implements AnalyticsClientInterface {
    constructor(private teamId: number, private groupId: string, config: BaseClientConfig = {}) {
        super(config);
    }

    getMarketingSubscriptionsTotalByStatus(type?: ContactType) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/statistics/current/contacts/total-${type}-by-subscription-status`;
        return this.makeCoreApiRequest(url, 'post', null, null, axiosCacheInterceptorRequestConfig);
    }

    getMarketingSubscriptionsTotalOptIns(params: AnalyticsDateRangeParam, type?: ContactType) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/statistics/time-series/contacts/total-${type}-opt-ins`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getMarketingSubscriptionsTotalOptOuts(params: AnalyticsDateRangeParam, type?: ContactType) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/statistics/time-series/contacts/total-${type}-opt-outs`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getContactsTotalCreated(params: AnalyticsDateRangeParam, type?: ContactType) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/statistics/time-series/contacts/total-${type}-created`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }
}
